import {useContext, useEffect, useState} from 'react'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import {useLocation} from '@s-ui/react-router'
import {LoginModalContext} from '@adv-mt/mt-context-login-modal'
import Layout from '@adv-mt/mt-layout-basic'
import NavigationRequireAuth from '@adv-mt/mt-navigation-require-auth'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import LinkFactory from '../../../components/LinkFactory/index.js'
import {ROUTES} from '../../../config/index.js'
import LoadingPage from './components/LoadingPage.js'
import UserForm from './components/UserForm/index.js'

const UserProfileComplete = () => {
  const {triggerLoginModal} = useContext(LoginModalContext)
  const {page: pageTrack} = useAnalyticsTrack()

  const {pathname, search} = useLocation()

  const isPurchaseFlow = pathname === ROUTES.USER.PROFILE_COMPLETE.PURCHASE

  const [userData, setUserData] = useState({
    data: null,
    error: null,
    loading: true
  })
  const {domain} = useContext(Context)

  const getUserById = async () => {
    setUserData({...userData, loading: true})
    const [error, userDataRes] = await domain.get('get_user_by_id_user_use_case').execute()

    if (error) setUserData({...userData, error, loading: false})
    else setUserData({...userData, data: userDataRes, loading: false})
  }

  useMount(() => {
    getUserById()
  })

  useMount(() => {
    if (isPurchaseFlow) {
      const {USER_PROFILE_COMPLETE_PURCHASE_BUYER_PAGE_NAME} = domain.get('config').get('page')

      domain
        .get('get_page_tracking_data_use_case')
        .execute({
          page: USER_PROFILE_COMPLETE_PURCHASE_BUYER_PAGE_NAME
        })
        .then(pageTrackingData => {
          pageTrack(pageTrackingData)
        })
    }
  })

  const userDataExists = Boolean(userData.data)
  const isUserVerified = userDataExists && userData.data?.verified

  useEffect(() => {
    if (!userDataExists || isUserVerified) return

    const config = domain.get('config')
    const {LOGIN_SOURCE_ID_TRANSACTONS} = config.get('login')
    const {VERIFICATION_REMINDER} = config.get('LOGIN_STEPS')
    triggerLoginModal({
      modalProps: {
        source: LOGIN_SOURCE_ID_TRANSACTONS,
        enableVerificationReminder: true,
        initialStep: VERIFICATION_REMINDER,
        onLogin: () => getUserById()
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDataExists, isUserVerified])

  return (
    <NavigationRequireAuth currentPath={`${pathname}${search}`}>
      <Layout.FullWidth linkFactory={LinkFactory} footerProps={{isSimple: true}}>
        <Layout.Container isFullWidth>
          {userData.loading && <LoadingPage />}
          {!userData.loading && isUserVerified && <UserForm userData={userData.data} />}
        </Layout.Container>
      </Layout.FullWidth>
    </NavigationRequireAuth>
  )
}

UserProfileComplete.displayName = 'UserProfileComplete'
UserProfileComplete.propTypes = {}

export default UserProfileComplete
